import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { GenericActions } from '../../actions';
import { useLocation } from 'react-router-dom';
import { traceContextService } from 'lib/opentelemetry';

const LocationContainer = ({ children }) => {
    const dispatch = useDispatch();
    const location = useLocation();

    useLayoutEffect(() => {
        dispatch(GenericActions.locationChange(location));
        traceContextService.startNavigationTrace(location.pathname);
    }, [location]);

    return children;
};

export default LocationContainer;
